import React from 'react'

const Bubble = ({ className, title, subtitle, children, color }) => (
  <div className={`relative ${className}`}>
    <div className={`bg-${color}-500 mb-6 h-full`}>
      <div className="p-3 md:p-6">
        {title ?
          <div className="text-3xl lg:text-4xl xl:text-5xl text-white leading-tight">
            { title }
          </div>
        : null }
        {subtitle ?
          <div className="text-indigo-700 text-2xl pt-2 leading-tight">
            { subtitle }
          </div>
        : null }
        <div className="mt-2">
          { children }
        </div>
      </div>
      <div className="absolute w-full pl-8 left-0 bottom-0">
        <svg className={`h-6 fill-current text-${color}-500`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 166.64 144.31"><g data-name="Layer 2"><path d="M0 0h166.64L125 72.16l-41.68 72.15-41.66-72.15z" data-name="Layer 1"/></g></svg>
      </div>
    </div>
  </div>
)


Bubble.defaultProps = {
  className: '',
  color: 'yellow',
}

export default Bubble
